import { InfoCircleTwoTone } from '@ant-design/icons';
import { Row, Tooltip } from 'antd';

import { Status } from 'components';

import { mapEnumToOptionsArray } from 'utils';

import { Links } from 'links';

import { TransactionDashboardDto } from 'codegen';
import { TColumn, TFieldProps } from 'types';

import { BackOutTransaction, RawAction, SendTransaction, UpdateTransaction } from '../Actions';

export const columns = (isAdmin: boolean): TColumn<TransactionDashboardDto>[] => [{
  type: TColumn.type.IDRedirect,
  width: 100,
  title: 'Snap ID',
  dataIndex: 'snapId',
  pathname: Links.Snaps,
}, {
  width: 150,
  title: 'Collector ID',
  dataIndex: 'collectorId',
}, {
  type: TColumn.type.Tags,
  width: 350,
  title: 'Transaction ID',
  dataIndex: 'transactionId',
}, {
  width: 120,
  title: 'Sponsor Code',
  dataIndex: 'sponsorCode',
  render: (value, { isEligibleForParticipationOffer }) => (
    <Row>
      {value}

      {isEligibleForParticipationOffer && (
        <Tooltip
          title='There is live Participation offer for transaction Sponsor'
          className='ml-1'
          placement='bottomLeft'
        >
          <InfoCircleTwoTone className='flex items-center' />
        </Tooltip>
      )}
    </Row>
  ),
}, {
  width: 100,
  title: 'Total Miles',
  dataIndex: 'totalMiles',
}, {
  width: 100,
  title: 'Status',
  dataIndex: 'status',
  render: (status, { errors }) => {
    if (errors?.length) {
      return (
        <Tooltip
          title={
            errors.map(({ reason }: { reason: string }, index: number) => (
              <div
                key={reason}
                className='mb-1'
              >
                {index + 1}
                {': '}
                {reason}
              </div>
            ))
          }
        >
          <span>
            <Status status={status} />
          </span>
        </Tooltip>
      );
    }

    return <Status status={status} />;
  },
}, {
  width: 80,
  title: 'Type',
  dataIndex: 'type',
}, {
  width: 150,
  title: 'Actions',
  fixed: 'right',
  hidden: !isAdmin,
  render: (_, { id, statusCode, snapId, canUpdate, status }) => (
    <>
      <RawAction snapId={snapId} id={id} />

      <UpdateTransaction
        snapId={snapId}
        status={status}
        canUpdate={canUpdate}
        transactionId={id}
      />

      <SendTransaction
        snapId={snapId}
        status={status}
        statusCode={statusCode}
        transactionId={id}
      />

      <BackOutTransaction
        snapId={snapId}
        status={status}
        statusCode={statusCode}
        transactionId={id}
      />
    </>
  ),
}];

export const fields = (isAdmin: boolean): TFieldProps[] => [{
  type: TFieldProps.type.DateRangePicker,
  name: 'submittedDates',
  colProps: { xs: 8, xxl: 4 },
  placeholder: 'Submitted Dates',
  itemClassName: 'mb-0',
}, {
  type: TFieldProps.type.Select,
  name: 'statuses',
  mode: 'multiple',
  options: mapEnumToOptionsArray(TransactionDashboardDto.status),
  colProps: { xs: 8, xxl: 4 },
  placeholder: 'Statuses',
  itemClassName: 'mb-0',
  tagRender: ({ value }) => <Status status={value} />,
  maxTagCount: 'responsive',
}, {
  type: TFieldProps.type.Text,
  name: 'riceTransactionId',
  colProps: { xs: 8, xxl: 4 },
  placeholder: ' Transaction Id',
  itemClassName: 'mb-0',
}, ...(isAdmin
  ? [{
    type: TFieldProps.type.Text,
    name: 'collectorNumber',
    colProps: { xs: 4 },
    placeholder: 'Collector Number',
    itemClassName: 'mb-0',
  }]
  : []
), {
  type: TFieldProps.type.Text,
  name: 'collectorId',
  colProps: { xs: 4 },
  placeholder: 'Collector ID',
  itemClassName: 'mb-0',
}];
